export const USERS_NOT_APPROVED_YET_WITH_COURSE_REQ =
  "usersNotApprovedYetWithCourseReq";
export const USERS_NOT_APPROVED_YET_WITH_COURSE_SUCCESS =
  "usersNotApprovedYetWithCourseSuccess";
export const USERS_NOT_APPROVED_YET_WITH_COURSE_FAIL =
  "usersNotApprovedYetWithCourseFail";
